import type { ZmanId } from "@kedaat/engine";
import type { ZmanRow } from "./zmanim";

/** Parts of the day for grouping the list of zmanim. */
export type DayPartId = "morning" | "afternoon" | "evening";

export const DAY_PARTS: readonly {
  id: DayPartId;
  label: string;
  zmanim: readonly ZmanId[];
}[] = [
  {
    id: "morning",
    label: "בוקר",
    zmanim: [
      "alos",
      "misheyakir",
      "sunrise",
      "sof_zman_shma",
      "sof_zman_tfila",
      "sof_zman_achilat_chametz",
      "sof_zman_biur_chametz",
    ],
  },
  {
    id: "afternoon",
    label: "צהריים",
    zmanim: ["chatzot", "mincha_gedola", "mincha_ketana", "plag_hamincha"],
  },
  {
    id: "evening",
    label: "ערב ולילה",
    zmanim: ["sunset", "tzeit", "tzeit_rt", "chatzot_night"],
  },
];

export function groupRows(rows: ZmanRow[]) {
  return DAY_PARTS.map((part) => ({
    ...part,
    rows: rows.filter((row) => part.zmanim.includes(row.zman.id)),
  })).filter((part) => part.rows.length > 0);
}
